
  import { Vue, Component, Prop } from "vue-property-decorator";

  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import ContractorChips from "@/components/companyProjects/ContractorChips.vue";
  import RouteNames from "@/entities/RouteNames";
  import ContractorChipData from "@/entities/ContractorChipData";
  import { Project_Activity, User } from "@/generated/graphql";
  import Roles from "@/entities/Roles";

  @Component({
    components: {
      CardBodyItem,
      ContractorChips,
    },
  })
  export default class ProjectContractorsCardItem extends Vue {
    @Prop({ type: Array, required: true }) readonly projectActivities!: Project_Activity[];
    @Prop({ type: String, required: true }) readonly projectId!: string;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;

    routeNames = RouteNames;

    get isAdmin(): boolean {
      return this.currentUser.role === Roles.ADMIN;
    }

    get projectContractors(): ContractorChipData[] {
      const contractors: { [key: string]: ContractorChipData } = {};

      this.projectActivities.forEach(({ contractor }) => {
        if (!contractor) {
          return;
        }

        const { id, user, deleted } = contractor;

        if (!contractors[id]) {
          const { given_name, family_name, avatar } = user;
          const name = `${given_name} ${family_name}`;
          const accessOpen: boolean = this.checkIsContractorAccessible(id);
          const routeName: RouteNames = accessOpen
            ? RouteNames.CONTRACTOR_DETAILS_ABOUT
            : RouteNames.CONTRACTOR_PUBLIC_PAGE;

          contractors[id] = {
            id: accessOpen ? id : user.id,
            name,
            avatar,
            deleted,
            activityCount: 1,
            routeName,
          };
          return;
        }

        contractors[id].activityCount++;
      });

      return Object.values(contractors);
    }

    checkIsContractorAccessible(contractorId: string): boolean {
      if (this.isAdmin) {
        return true
      }
      const managerHasAccess = this.currentUser.manager?.contractors.some(contractor => {
        return contractor.id === contractorId && contractor.approved;
      });
      return Boolean(managerHasAccess);
    }

    get alignment(): string {
      return this.projectContractors.length ? "items-baseline" : "items-center";
    }
  }
